import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import baseURL from '../../Components/url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faGlobe,
    faHeartbeat,
    faSeedling,
    faHandshake,
    faSpinner,
    faUserPlus,
    faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import './QuienesSomosPage.css';

export default function QuienesSomosPage() {
    const [secciones, setSecciones] = useState([]);
    const [contacto, setContacto] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        cargarDatos();
        cargarContacto();
    }, []);

    const cargarDatos = () => {
        setLoading(true);
        fetch(`${baseURL}/quienesSomosGet.php`, {
            method: 'GET',
        })
            .then((res) => res.json())
            .then((data) => {
                setSecciones(data.quienesSomos || []);
                setLoading(false);
            })
            .catch((err) => {
                console.error('Error al cargar Quiénes Somos:', err);
                setLoading(false);
            });
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then((res) => res.json())
            .then((data) => {
                const lista = data.contacto || [];
                setContacto(lista[0] || {});
            })
            .catch((err) => console.error('Error al cargar contacto:', err));
    };

    const telefonoLimpio = (contacto.telefono || '').replace(/\D/g, '');
    const seccionPrincipal = secciones[0] || null;

    return (
        <div className="quienes-page-wrapper">
            <div className="quienes-page-container">
                {/* Migas de pan / Breadcrumbs */}
                <div className="quienes-breadcrumbs">
                    <Link to="/">Inicio</Link>
                    <FontAwesomeIcon icon={faChevronRight} size="xs" />
                    <span>{seccionPrincipal ? seccionPrincipal.titulo : 'Acerca de DXN'}</span>
                </div>

                {loading ? (
                    <div className="quienes-loading">
                        <FontAwesomeIcon icon={faSpinner} spin size="3x" />
                        <p>Cargando información corporativa...</p>
                    </div>
                ) : (
                    <>
                        {/* Cabecera / Header Principal */}
                        <div className="quienes-header-card">
                            <div className="quienes-header-title-box">
                                <span className="quienes-badge">
                                    <FontAwesomeIcon icon={faUsers} /> Centro de Servicio Autorizado DXN
                                </span>
                                <h1>{seccionPrincipal ? seccionPrincipal.titulo : 'Acerca de DXN'}</h1>
                                <p>
                                    Promoviendo la salud, la riqueza y la felicidad a través del Ganoderma lucidum
                                    en Tingo María, el Perú y en todo el mundo.
                                </p>
                            </div>
                        </div>

                        {/* Secciones de Contenido (Renderiza las registradas en el dashboard) */}
                        {secciones.length > 0 ? (
                            secciones.map((sec, index) => (
                                <div className="quienes-card-section" key={sec.idQuienesSomos || index}>
                                    {index > 0 && (
                                        <h2 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#0f172a', marginBottom: '1.5rem' }}>
                                            {sec.titulo}
                                        </h2>
                                    )}
                                    <div className="quienes-media-layout">
                                        {sec.imagen && (
                                            <div className="quienes-hero-img-wrap">
                                                <img
                                                    src={sec.imagen}
                                                    alt={sec.titulo}
                                                    className="quienes-hero-img"
                                                />
                                            </div>
                                        )}
                                        <div className="quienes-text-content">
                                            {sec.descripcion.split('\n').map((parrafo, pIdx) => (
                                                <p key={pIdx}>{parrafo}</p>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="quienes-card-section">
                                <div className="quienes-text-content">
                                    <p>
                                        DXN fue fundada en 1993 por Datuk Dr. Lim Siow Jin con el firme propósito
                                        de llevar bienestar a todas las familias mediante los beneficios del Ganoderma lucidum,
                                        el Rey de las Hierbas. Con presencia en más de 180 países, DXN es líder mundial
                                        en cultivo, procesamiento y distribución de productos saludables de altísima calidad.
                                    </p>
                                </div>
                            </div>
                        )}

                        {/* Pilares Corporativos de DXN */}
                        <div className="quienes-features-grid">
                            <div className="quienes-feature-card">
                                <div className="quienes-feature-icon">
                                    <FontAwesomeIcon icon={faSeedling} />
                                </div>
                                <h3>Un Dragón</h3>
                                <p>
                                    Todo el proceso de cultivo, producción y comercialización es realizado íntegramente
                                    por DXN bajo los más estrictos controles mundiales de calidad (ISO 14001, ISO 9001, GMP).
                                </p>
                            </div>

                            <div className="quienes-feature-card">
                                <div className="quienes-feature-icon">
                                    <FontAwesomeIcon icon={faGlobe} />
                                </div>
                                <h3>Un Mundo, Un Mercado</h3>
                                <p>
                                    Un solo código de afiliación te permite consumir y expandir tu red de distribución
                                    a nivel global en más de 180 países con igualdad de beneficios y oportunidades.
                                </p>
                            </div>

                            <div className="quienes-feature-card">
                                <div className="quienes-feature-icon">
                                    <FontAwesomeIcon icon={faHeartbeat} />
                                </div>
                                <h3>Salud y Bienestar</h3>
                                <p>
                                    Nuestros productos naturales con extracto puro de Ganoderma lucidum y espirulina
                                    ayudan al organismo a desintoxicar, equilibrar y fortalecer el sistema inmunológico.
                                </p>
                            </div>

                            <div className="quienes-feature-card">
                                <div className="quienes-feature-icon">
                                    <FontAwesomeIcon icon={faHandshake} />
                                </div>
                                <h3>Atención Oficial</h3>
                                <p>
                                    En Tingo María ponemos a tu disposición atención personalizada, orientación sobre productos,
                                    capacitaciones periódicas y disponibilidad inmediata de stock oficial.
                                </p>
                            </div>
                        </div>

                        {/* Llamado a la Acción (CTA) */}
                        <div className="quienes-cta-card">
                            <h2>¿Listo para mejorar tu salud y transformar tu futuro?</h2>
                            <p>
                                Únete hoy a la comunidad DXN en Tingo María y empieza a disfrutar de los beneficios
                                de nuestros productos y de nuestro plan de crecimiento personal y financiero.
                            </p>
                            <div className="quienes-cta-buttons">
                                <a
                                    href="https://eworld.dxn2u.com/s/accreg/es419/011321616"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-cta-afiliate"
                                >
                                    <FontAwesomeIcon icon={faUserPlus} /> ¡Afíliate ahora a DXN!
                                </a>
                                {telefonoLimpio && (
                                    <a
                                        href={`https://api.whatsapp.com/send?phone=${telefonoLimpio}&text=${encodeURIComponent('Hola, deseo mayor información sobre DXN y cómo adquirir los productos o afiliarme.')}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-cta-whatsapp"
                                    >
                                        <i className="fa fa-whatsapp"></i> Contáctanos por WhatsApp
                                    </a>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
